module.exports = __webpack_public_path__ + "static/media/experience-background-desktop.0ea64f7a.webp";